import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import React from "react";
import { YesNoCustomControlProps } from "../Utils/Interfaces";
import { HasValue } from "../sharedCode/HelperMethods";

// TODO ROUTING - the Y click is fubar - toggles between Y & N
export function YesNoButtons(props: YesNoCustomControlProps): JSX.Element {
    const toggleSx = { width: 50 };

    return (
        <ToggleButtonGroup
            disabled={props.isDisabled}
            value={!HasValue(props.initialValue) ? "?" : props.initialValue ? "Y" : "N"}
            exclusive
            onChange={handleOnChange}
            sx={{ paddingTop: 0.5, paddingBottom: 1, paddingLeft: 2, justifyContent: "start" }}>
            <ToggleButton sx={toggleSx} color={"error"} value="?" disabled></ToggleButton>
            <ToggleButton sx={toggleSx} value="N">
                NO
            </ToggleButton>
            <ToggleButton sx={toggleSx} value="Y">
                YES
            </ToggleButton>
        </ToggleButtonGroup>
    );

    function handleOnChange(event: React.MouseEvent<HTMLElement>, newValue: string | null) {
        // NB: use either onChange or mergeChanges, not both
        const result = newValue === "?" ? null : newValue === "Y";
        props.onChange(props.sourceId, result);

        const resultToMerge = newValue === "?" ? null : newValue === "Y" ? 1 : 0;
        props.mergeChanges(props.sourceId, { [props.sourceProperty]: resultToMerge });
    }
}
